import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ANewChapterBegins from "./sections/ANewChapterBegins";
import MaternityMoments from "./sections/MaternityMoments";
import TheDayOfCelebration from "./sections/TheDayOfCelebration";
import ShowerTheOhlsons from "./sections/ShowerTheOhlsons";
import SendYourLove from "./sections/SendYourLove";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ANewChapterBegins />
      <MaternityMoments />
      <TheDayOfCelebration />
      <ShowerTheOhlsons />
      <SendYourLove />
      <Footer />
    </div>;
}